module.exports = __webpack_public_path__ + "img/salt-creek.95ed0c5b.png";